<script setup>
const { t } = useI18n()
const { hasOnlyOneProvider, isAuthenticated, hasProviderId } = useSessionData()
const { isHomePage } = useIsHomePage()
const { headerHeightClasses } = useHeaderConfig()
</script>

<template>
  <div
    class="app-header fixed left-0 right-0 top-0 z-fixed+1 flex flex-col justify-center bg-white shadow"
    :class="[headerHeightClasses]"
  >
    <MainContainer class="w-full flex flex-row items-center py-6px lt-sm:(px-4) sm:(px-6)">
      <a v-if="isHomePage">
        <AppLogo />
      </a>
      <template v-else>
        <AppNavMenuMobileToggleButton class="me-2 !sm:hidden" />
        <AppLogo />
      </template>
      <div class="flex flex-row !ms-auto">
        <BaseLink
          v-if="!isHomePage && !hasOnlyOneProvider"
          url="/dashboard"
          class="btn-ghost-secondary me-2 btn-xs flex items-center justify-center text-secondary uppercase hover:bg-secondary-100 hover:bg-opacity-75 lt-sm:!hidden"
        >
          <DSIcon
            icon="i-far-house"
            class="mr-2 text-12"
          />
          <span>{{ t('Home') }}</span>
        </BaseLink>
        <AppLoginButton v-if="!isAuthenticated && hasProviderId" />
        <AppProfileSwitcher v-if="isAuthenticated" />
      </div>
    </MainContainer>
  </div>
</template>

<i18n>
{
  "en-us": {
    "Home": "Home",
    "TeamUp Logo": "TeamUp Logo"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Home": "Startseite",
  "TeamUp Logo": "TeamUp-Logo"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Home": "Accueil",
  "TeamUp Logo": "Logo TeamUp"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Home": "Inicio",
  "TeamUp Logo": "Logo de TeamUp"
}
</i18n>
